exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-head[data-v-a08c9068]{position:-webkit-sticky;position:sticky;top:143px;z-index:990;background-color:#fff}.bootstrap-dark .sticky-head[data-v-a08c9068]{background-color:#343a40}[data-v-a08c9068] .multiselect__input::-moz-placeholder{color:#dcdcdc}[data-v-a08c9068] .multiselect__input:-ms-input-placeholder{color:#dcdcdc}[data-v-a08c9068] .multiselect__input::placeholder{color:#dcdcdc}", ""]);

// exports
